import React from "react";

export default function CreativeLoaderView() {
  return <React.Fragment>
      <p>loading...</p>
    </React.Fragment>;
}
